import Vue from 'vue'
import Router from 'vue-router'
import http from '../http/index'
import Cookies from 'js-cookie'
import $ from 'jquery'
import config from '../config/config'
import { getInfo } from '../config/browser'
import cryptojs from '@/config/util'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  routes: [
  {
    name: '',
    path: '/',
    meta: {
      title: '首页'
    },
    component: resolve => require(['@/view/index.vue'], resolve),
    children: [
      {
        name: '',
        path: '/',
        meta: {
          title: '首页'
        },
        component: resolve => require(['@/view/init/index.vue'], resolve)
      },{
        name: 'index',
        path: '/index',
        meta: {
          title: '首页'
        },
        component: resolve => require(['@/view/init/index.vue'], resolve)
      },{
        name: 'init',
        path: '/init',
        meta: {
          title: '扫码落地页'
        },
        component: resolve => require(['@/view/init/init.vue'], resolve)
      },
      {
        name: 'success',
        path: '/success',
        meta: {
          title: '激活成功'
        },
        component: resolve => require(['@/view/success/success.vue'], resolve)
      },
      {
        name: 'mybook',
        path: '/mybook',
        meta: {
          title: '我的激活'
        },
        component: resolve => require(['@/view/mybook/mybook.vue'], resolve)
      },
      {
        name: 'loading',
        path: '/loading',
        meta: {
          title: '激活中'
        },
        component: resolve => require(['@/view/loading/loading.vue'], resolve)
      },
      {
        name: 'help',
        path: '/help',
        meta: {
          title: '使用帮助'
        },
        component: resolve => require(['@/view/help/list.vue'], resolve)
      },
      {
        name: 'help',
        path: '/detail',
        meta: {
          title: '使用帮助'
        },
        component: resolve => require(['@/view/help/detail.vue'], resolve)
      },
      {
        name: 'book',
        path: '/book',
        meta: {
          title: '一码多书'
        },
        component: resolve => require(['@/view/book/list.vue'], resolve)
      },
      {
        name: 'feedback',
        path: '/feedback',
        meta: {
          title: '意见反馈'
        },
        component: resolve => require(['@/view/feedback/index.vue'], resolve)
      }
    ]
  },
  {
    name: 'download',
    path: '/download',
    meta: {
      title: 'app下载'
    },
    component: resolve => require(['@/view/download/index.vue'], resolve)
  }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path.indexOf('init/%3Fcn') > 0 || to.path.indexOf('init%3Fcn') > 0 || to.path.indexOf('init/%3Fen') > 0 || to.path.indexOf('init%3Fen') > 0) {
    // 扫码落地页
    let data = decodeURIComponent(window.location.hash)
    var index = data.indexOf("?");
    var str = data.substr(index + 1);
    Cookies.set("bookInfo", str)
    router.push({ path: `/init?` + str })
  }
  // if (to.path.indexOf('init/11/') > 0) {
  //   var theRequest = new Object();
  //   var index = data.indexOf("?");
  //   let strs
  //   if (index != -1) {
  //     var str = data.substr(index + 1);
  //     strs = str.split("&");
  // 		for(var i = 0; i < strs.length; i ++) {
  // 			theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1]);
  //     }
  //   }
  //   router.push({ path: `/init?theRequest=` + str })
  //   console.log(theRequest)
  // }

  // window.location.href = 'http://localhost:3001/#/web/memberlogin/'

  var isLogin = false
  // 获取本地登录状态
  http.get('web/member/logined').then((res) => {
    if (res.data.code !== '200') {
      return this.$toast({
        message: res.data.msg,
        icon: 'warning-o',
      })
    }
    if (!res.data.data.isLogin) {
      Cookies.remove('ysym_UserName')
      // router.push({ path: `/index`})
    } else {
      Cookies.set("ysym_UserName", res.data.data.userName)
      isLogin = true
    }
  })

  // 获取配置信息
  http.get('web/zas/config').then((res) => {
    if (res.data.code !== '200') {
      return
    }
    var ssoWebClientID = res.data.data.ssoWebClientID
    var ssoWebServer = res.data.data.ssoWebServer
    var ssoWebAESIV = res.data.data.ssoWebAESIV
    var ssoWebAESKey = res.data.data.ssoWebAESKey

    const validate = getInfo()
    const headers = { clientId: ssoWebClientID }
    const params = { client_id: ssoWebClientID, Validate: validate }
    const data = { header:headers, body:params, timestamp:Date.now() }

    $.ajax({
      url: ssoWebServer + 'zapiv3e/browser/login/onlineValidata',
      type: 'POST',
      data: {
        data: cryptojs.encrypt(JSON.stringify(data),ssoWebAESIV,ssoWebAESKey)
      },
      xhrFields: {
        withCredentials: true,
      },
      headers: headers,
      success: function (response) {
        let text = response.data
        let responsejson = JSON.parse(cryptojs.decrypt(text, ssoWebAESIV, ssoWebAESKey))
        let ssoUsername = responsejson.body.data && responsejson.body.data.name ? responsejson.body.data.name : ""
        var isSSOLogin = false
        if (ssoUsername && responsejson.body.data) {
          isSSOLogin = true
        }
        // 当前SSO登录用户与本应用登录用户名不一致时，当前SSO用户进行应用内登录
        var ysym_UserName = Cookies.get("ysym_UserName")
        if (ssoUsername && ysym_UserName && ysym_UserName != ssoUsername) {
          window.location.href = config.host + 'v1/web/memberlogin/?referer=' + encodeURIComponent(window.location.href)
        }
        // SSO登陆了，本地没登录，进行SSO登陆
        if (isSSOLogin && !isLogin) {
          window.location.href = config.host + 'v1/web/memberlogin/?referer=' + encodeURIComponent(window.location.href)
        }
        //  SSO登出了，本地还在登陆，进行SSO登出
        if (!isSSOLogin && isLogin) {
          window.location.href = config.host + 'v1/web/memberlogout/'
        }

        next()

      },
      error: function () {
        next()
      }
    })

  })

  // next()
})
// router.afterEach(() => {
//   window.scrollTo(0, 0)
// })
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js